import { vMarketing } from './view.js';
import { actions } from './actions.js';

export default {
  id: 'marketing', label: 'Marketing', icon: 'megaphone', nav: true,
  show: (u) => u.perm.mkt || u.role === 'admin',
  view: vMarketing, actions
};
